<style lang="scss"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('mojuxinxi') }}
        </p>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }" style="display: flex;flex-direction: column;justify-content: space-around">
      <div style="flex-shrink: 0;" @click="openYaZhudao()">
        <img style="width: 100%;padding:  0px 24px 10px 24px;height: auto;" :src="equipment.imgSrcDynamic || equipment.imgSrcStatic" />
      </div>
      <div style="">
        <div style="display: flex;height: 50%;">
          <div style="width: 50%;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('dangqianmohao') }}</p>
            <p style="font-size: 18px;color: #ffffff;">{{ tabsData.eqPoints['CurrentMoldNo'] }}</p>
          </div>
          <div style="width: 50%;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('shiji') + '/' + $t('biaozhunzhouqi') + '(' + $t('miao') + ')' }}</p>
            <p style="font-size: 18px;color: #ffffff;">{{ tabsData.eqPoints['ActualCycle'] && Number(tabsData.eqPoints['ActualCycle']).toFixed(1) }}&nbsp;/&nbsp;{{ tabsData.eqPoints['StandardCycle'] ? Number(tabsData.eqPoints['StandardCycle']).toFixed(1) : '-' }}</p>
          </div>
        </div>
        <div style="display: flex;height: 50%;margin-top: 8px;">
          <div style="width: 50%;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('moxueshu') }}</p>
            <p style="font-size: 18px;color: #ffffff;">{{ tabsData.eqPoints['CavityNum'] != null ? (tabsData.eqPoints['CavityNum'] * 1).toFixed(0) : '-' }}</p>
          </div>
          <div style="width: 50%;">
            <p style="font-size: 14px;color: #C0C4CC;">{{ $t('dangqianliaohao') }}</p>
            <p style="font-size: 18px;color: #ffffff;">{{ tabsData.eqPoints['CurrentMaterialNo'] }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_equipment_mould',
  components: {},
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      contentHeight: 0
    };
  },
  created() {
    // this.openYaZhudao()
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 10;
      }, 500);
    },
    openYaZhudao() {
      this.utils.event_hub.$emit('SHOW_WORKSHOP_ISLAND');
    }
  }
};
</script>
